<template>
    <div class="classDetail">
        <div class="detailTitle flex">
            <div class="left flex">
                <img :src=" info.coveratturl && info.coveratturl.split(',')[0]" alt="">
                <div class="classDesc ml-20">
                    <p class="name mt-10">{{info.name}}</p>
                    <p class="time mt-10">{{info.datetime}}</p>
                    <div class="tagsBox flex mt-10">
                        <div v-if="info.status != 30 && info.status!=100" class="tag mr-20">{{info.statusname}}</div>
                        <div v-else class="tag tag1">{{info.statusname}}</div>
                    </div>
                    <div class="stuData mt-10">
                        <span class="mr-10">学员数：{{info.totalstudentcount}}</span>
                        <span class="mr-10">学分数：{{info.totalscore}}</span>
                        <span>已上课/排课数：{{info.finishperiodcount}}/{{info.totalperiodcount}}</span>
                    </div>
                </div>
            </div>
            <div @click="goBack" class="replay pointer"> 返回班级</div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="学员信息" name="first">
                <StuInfo ref="stuInfo" />
            </el-tab-pane>
            <el-tab-pane label="课程信息" name="second">
                <ClassInfo ref="classInfo" />
            </el-tab-pane>
            <el-tab-pane label="排课信息" name="third">
                <Schedule :isShowPk="true" :className="info.name"  ref="Schedule" />
            </el-tab-pane>
            <el-tab-pane label="学情信息" name="fourth">
                <StudyStatus ref="studyStatus" />
            </el-tab-pane>
            <el-tab-pane label="作业信息"  name="five">
                <WorkList :classCode="$route.query.code" :type="true" ref="WorkList" />
            </el-tab-pane>
            <el-tab-pane label="考试信息"  name="six">
                <TestList :classCode="$route.query.code" :type="true" ref="TestList" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import StuInfo from './classDetail/stuInfo.vue'
import ClassInfo from './classDetail/classInfo.vue'
import StudyStatus from './classDetail/studyStatus.vue'
import WorkList from './classDetail/workList.vue'
import {getClassInfo} from '@/api/measApi/teachManagement.js'
import TestList from './classDetail/testList.vue'
import Schedule from './components/schedule.vue'
export default {
    data(){
        return {
            activeName: 'first',
            params: {
                code: ''
            },
            info: []
        }
    },
    components: {
        StuInfo,
        ClassInfo,
        StudyStatus,
        WorkList,
        TestList,
        Schedule
    },
    created(){
        this.params.code = this.$route.query.code
        if(this.$route.query.type === 'pk'){
            this.activeName = 'third'
        }
        this.getClassInfo()
        this.$nextTick(() => {
            this.$refs.stuInfo.init()
        })
    },
    methods: {
        getClassInfo(){
            getClassInfo(this.params).then(res => {
                this.info = res.data
                console.log(res,'top')
            })
        },
        handleClick(e){
            e.$children[0].init()

        },
        goBack(){
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="scss" scoped>
.detailTitle{
    background: #F6F7FB;
    padding: 20px;
    width: 100%;
    justify-content: space-between;
    .left{
        img{
            height: 117px;
            width: 117px;
        }
        .classDesc{
            .name{
                font-size: 14px;
                color: #4D5560;
            }
            .time{
                font-size: 12px;
                color: #666666;
            }
            .tagsBox{
                align-items: center;
                .tag{
                    text-align: center;
                    width: 44px;
                    height: 25px;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #999999;
                    font-size: 12px;
                    line-height: 25px;
                    color: #666666;
                    background: #F6F7FB;
                }
                .tag1{
                    background: #6AC33A;
                    color: white;
                }
            }
            .stuData{
                color: #666666;
            }
        }
    }
    .replay{
        width: 88px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #DCDFE6;
        color: #666666;
        font-size: 14px;
    }
}
</style>